import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './FloatingNavbar.css';

const FloatingNavbar = () => {
  const location = useLocation();

  return (
    <nav className="floating-navbar">
      <div className="nav-links">
        <Link 
          to="/" 
          className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
        >
          Home
        </Link>
        <Link 
          to="/about" 
          className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
        >
          About
        </Link>
        <Link 
          to="/projects" 
          className={`nav-link ${location.pathname.startsWith('/projects') ? 'active' : ''}`}
        >
          Projects
        </Link>
        <Link 
          to="/contact" 
          className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
        >
          Contact
        </Link>
      </div>
    </nav>
  );
};

export default FloatingNavbar; 